'use strict';

angular.module('ntmApp').factory('DailyPlanContext', ['DailyPlanService', 'TopBar', 'LocationTilesViewModel', 'RoomTilesViewModel', 'OtherActivitiesViewModel', 'QCCheckActivitiesViewModel', 'RoomDetailsViewModel', 'FlashService', 'Constants', 'Utils', 'SignalR',
function (DailyPlanService, TopBar, LocationTilesViewModel, RoomTilesViewModel, OtherActivitiesViewModel, QCCheckActivitiesViewModel, RoomDetailsViewModel, FlashService, Constants, Utils, SignalR) {

    function DailyPlanContext() {

        var self = this;

        self.init = function () {

            self.isLoading = true;
            FlashService.ShowProgressBar();
            DailyPlanService.GetTopBar({ date: new Date(), appId: 14, appOptId: 400066 }).then(function (result) {

                self.isLoading = false;
                FlashService.HideProgressBar();

                if (!result.data.maxScheduleDate || moment().startOf('day').isAfter(moment(result.data.maxScheduleDate))) {
                    Utils.OpenModal('There are no scheduled activities generated for today. Cannot access Daily Plan.', 'ng1/src/common/alertPopup.html');
                    return;
                }

                if (result.data.units.length < 1) {
                    Utils.OpenModal('You are not set up on any Units.', 'ng1/src/common/alertPopup.html');
                    return;
                }

                self.TopBar.initTopBar(result.data);
            });
        };

        self.getViewModeAndSelectedDate = function () {
            return {
                unitId: self.getViewMode(),
                date: moment(self.TopBar.dateDisplayed)
            };
        };

        self.getViewModeSelectedDateAndLocation = function () {

            var request = self.getViewModeAndSelectedDate();
            request.locationId = self.TopBar.BreadCrumbs.selectedLocation.id;
            request.unitMode = self.TopBar.BreadCrumbs.selectedLocation.type;

            return request;
        };

        self.getViewModeTypeString = function () {
            if (self.TopBar.BreadCrumbs.selectedLocation.type === 0) {
                return 'Area';
            } else if (self.TopBar.BreadCrumbs.selectedLocation.type === 1) {
                return 'Facility';
            }

            return '';
        };

        self.getViewModeSelectedDateAndRoomInfo = function () {
            var request = self.getViewModeAndSelectedDate();

            request.roomNumber = self.TopBar.BreadCrumbs.selectedRoom.roomNumber;
            request.facilityCode = self.TopBar.BreadCrumbs.selectedRoom.facilityCode;

            return request;
        };

        self.getRoomInfo = function () {
            
            return {
                roomNumber: self.TopBar.BreadCrumbs.selectedRoom.roomNumber,
                facilityCode: self.TopBar.BreadCrumbs.selectedRoom.facilityCode
            };
        };

        self.getViewMode = function () {
            return parseInt(self.TopBar.BreadCrumbs.selectedViewType.id) || null;
        };

        self.is1StLevel = function () {
            return self.TopBar.BreadCrumbs.getCurrentLevel() === Constants.DailyPlanLevels.LEVEL1;
        };

        self.is2ndLevel = function () {
            return self.TopBar.BreadCrumbs.getCurrentLevel() === Constants.DailyPlanLevels.LEVEL2;
        };

        self.is3rdLevel = function () {
            return self.TopBar.BreadCrumbs.getCurrentLevel() === Constants.DailyPlanLevels.LEVEL3;
        };

        self.displayActivitiesForSelectedType = function (type) {
            if (type !== self.selectedActivityType) {
                self.selectedActivityType = type;

                var resourcePool = self.CurrentView.ResourcePool;
                var statistic = self.CurrentView.statistic;
                var nonDailyActivities = self.CurrentView.NonDailyActivities;

                switch (self.selectedActivityType) {
                    case 'Room Activities':
                        self.CurrentView = new RoomTilesViewModel(self);
                        break;
                    case 'Other Activities':
                        self.CurrentView = new OtherActivitiesViewModel(self);
                        break;
                    case 'QC Check Activities':
                        self.CurrentView = new QCCheckActivitiesViewModel(self);
                        break;
                }
                
                self.CurrentView.ResourcePool = resourcePool;
                self.CurrentView.statistic = statistic;
                self.CurrentView.NonDailyActivities = nonDailyActivities;
                self.CurrentView.NonDailyActivities.performFiltering();

                self.CurrentView.load(true);
            }
        };

        self.closeSignalRConnection = function () {
            SignalR.Stop();
        };

        function initialize() {
            self.activityTypes = ['Room Activities', 'Other Activities', 'QC Check Activities'];
            self.selectedActivityType = 'Room Activities';

            self.TopBar = new TopBar(self);
            self.CurrentView = new LocationTilesViewModel(self);

            self.TopBar.onDateChanged(function () {
                if (self.CurrentView.ResourcePool) {
                    self.CurrentView.ResourcePool.initialized = false;
                }
                self.CurrentView.load();
            });

            self.TopBar.BreadCrumbs.onViewTypeChanged(function () {
                self.CurrentView = new LocationTilesViewModel(self);
                self.CurrentView.load();
            });


            self.TopBar.BreadCrumbs.onLocationChanged(function (resetRP) {
                var resourcePool = self.CurrentView.ResourcePool;
                var statistic = self.CurrentView.statistic;
                var nonDailyActivities = self.CurrentView.NonDailyActivities;

                switch (self.selectedActivityType) {
                    case 'Room Activities':
                        self.CurrentView = new RoomTilesViewModel(self);
                        break;
                    case 'Other Activities':
                        self.CurrentView = new OtherActivitiesViewModel(self);
                        break;
                    case 'QC Check Activities':
                        self.CurrentView = new QCCheckActivitiesViewModel(self);
                        break;
                }

                if (resourcePool && resourcePool.initialized && !resetRP) {
                    self.CurrentView.ResourcePool = resourcePool;
                    self.CurrentView.statistic = statistic;
                }
                self.CurrentView.NonDailyActivities = nonDailyActivities;
                self.CurrentView.load();
            });

            self.TopBar.BreadCrumbs.onRoomChanged(function () {
                var resourcePool = self.CurrentView.ResourcePool;
                var statistic = self.CurrentView.statistic;
                var nonDailyActivities = self.CurrentView.NonDailyActivities;

                self.CurrentView = new RoomDetailsViewModel(self);
                if (resourcePool && resourcePool.initialized) {
                    self.CurrentView.ResourcePool = resourcePool;
                    self.CurrentView.statistic = statistic;
                }
                self.CurrentView.NonDailyActivities = nonDailyActivities;
                self.CurrentView.load();
            });

            var onTopBarChangingAction = function (changeAction) {

                if (self.CurrentView.isChanged()) {
                    self.CurrentView.confirmViewLeaving(changeAction);
                } else {
                    if (changeAction) {
                        changeAction();
                    }
                }
            };

            self.TopBar.onDateChanging(onTopBarChangingAction);
            self.TopBar.BreadCrumbs.onBreadCrumbChanging(onTopBarChangingAction);

            SignalR.StartConnection(function (callBack) {
                self.CurrentView.updateViewOnWebSocketsResponse(callBack);
            }, '/DailyStatistic');
        }

        initialize();
    }

    return (DailyPlanContext);

}]);
